/**
 * EDI-SIG Frontend Auth & Session Management Module
 */
let API_BASE = '/api';
let showToast = () => {};

if (typeof require !== 'undefined') {
  try {
    const config = require('./config.js');
    API_BASE = config.API_BASE;
    showToast = config.showToast;
  } catch (e) {}
}

const Auth = {
  currentUser: null,

  async checkAuth() {
    try {
      const token = localStorage.getItem('edi_sig_token');
      const headers = token ? { 'Authorization': `Bearer ${token}` } : {};

      const response = await fetch(`${API_BASE}/auth/me`, {
        credentials: 'same-origin',
        headers
      });

      if (response.ok) {
        const data = await response.json();
        this.setCurrentUser(data.user || data);
        return true;
      } else {
        this.showLoginPage();
        return false;
      }
    } catch (err) {
      console.error('Auth check error:', err);
      this.showLoginPage();
      return false;
    }
  },

  isAuthenticated() {
    return !!this.currentUser;
  },

  setCurrentUser(user) {
    this.currentUser = user;
    if (typeof $ !== 'undefined') {
      $('#navbar-username').text(user.username);
      $('#dropdown-fullname').text(user.full_name || user.username);
      $('#dropdown-role').text(user.role_name);

      if (user.role_name === 'admin') {
        $('.admin-only').show();
      } else {
        $('.admin-only').hide();
      }

      $('#login-page').hide();
      $('#app-wrapper').show();
    }

    if (typeof feather !== 'undefined') {
      feather.replace();
    }
  },

  showLoginPage() {
    this.currentUser = null;
    if (typeof $ !== 'undefined') {
      $('#app-wrapper').hide();
      $('#login-page').show();
    }
    if (typeof feather !== 'undefined') {
      feather.replace();
    }
  },

  async handleLogin(e, onSuccess) {
    if (e && e.preventDefault) e.preventDefault();
    const username = typeof $ !== 'undefined' ? $('#login-username').val().trim() : '';
    const password = typeof $ !== 'undefined' ? $('#login-password').val() : '';
    const errorDiv = typeof $ !== 'undefined' ? $('#login-error') : null;
    const submitBtn = typeof $ !== 'undefined' ? $('#login-submit-btn') : null;
    
    if (errorDiv) errorDiv.hide().text('');
    if (submitBtn) {
      submitBtn.prop('disabled', true);
      submitBtn.find('.login-btn-text').hide();
      submitBtn.find('.login-btn-spinner').show();
    }

    try {
      const response = await fetch(`${API_BASE}/auth/login`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });

      if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        throw new Error(errData.error || 'Invalid login credentials.');
      }

      const data = await response.json();
      if (data.token) {
        localStorage.setItem('edi_sig_token', data.token);
      }
      this.setCurrentUser(data.user);
      
      showToast('success', 'Logged in successfully.');
      if (onSuccess) onSuccess();
    } catch (err) {
      if (errorDiv) errorDiv.text(err.message).show();
    } finally {
      if (submitBtn) {
        submitBtn.prop('disabled', false);
        submitBtn.find('.login-btn-spinner').hide();
        submitBtn.find('.login-btn-text').show();
      }
    }
  },

  async logout() {
    try {
      await fetch(`${API_BASE}/auth/logout`, {
        method: 'POST',
        credentials: 'same-origin'
      });
    } catch (e) {
      // Ignore network errors on logout
    }
    localStorage.removeItem('edi_sig_token');
    this.showLoginPage();
    showToast('info', 'Logged out.');
  }
};

if (typeof module !== 'undefined' && module.exports) {
  module.exports = { Auth };
}
